import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { Close } from '@mui/icons-material';

export const CloseRight = () => {
  const isMobile = useMediaQuery({ maxWidth: 1000 });
  const isSmallMobile = useMediaQuery({ maxWidth: 374 });

  return (
    <Close
      style={{
        color: 'black',
        fontSize: isSmallMobile ? '20px' : isMobile ? '24px' : '28px'
      }}
    />
  );
};
